import AnimalModItem from "../AnimalModItem";

const handler = ({log, translationManager, index}) => {
    const rawParams = log?.log?.Params?.[index ?? 0] ?? {};
    const params = log.getCodeParams(rawParams);

    const changes = [];
    // Przeglądamy surowe parametry w poszukiwaniu par oldX / newX
    const oldKeys = Object.keys(rawParams).filter((k) => k.startsWith("old"));
    for (const oldKey of oldKeys) {
        const baseName = oldKey.replace(/^old/, ""); // np. "RFID"
        const newKey = `new${baseName}`;
        const path =
            rawParams[oldKey]?.path?.replace(/^ObjOld\./, "") ?? baseName;

        if (rawParams[newKey]) {
            changes.push({
                name: translationManager.translate(`rfid`),
                oldValue: params[oldKey],
                newValue: params[newKey],
                path,
            });
        }
    }

    return new AnimalModItem({
        invokedBy: log.getUserObj(),
        timestamp: log.log.DtaCrtTime,
        animalId: log.log.ObjID,
        comment: log.getComment(),
        changes,
        title: translationManager.translate(
            "animalModList.editAnimalRFID",
            params
        ),
        id: log.log.LogID,
        objectId: log.log.ObjOld?.EvID,
        subgroupName: translationManager.format(
            "subgroupNameFormatter",
            log.log.ObjID
        ),
    });
};

handler.RegExp = new RegExp(`^2053$`, "g");

export default handler;
